<template>
  <div class="list position-relative" :class="{
    'single-number' : block.type === 'SingleList',
    'bullets' : block.type === 'BulletList'
  }">
    <ol>
      <li v-for="(item, index) in this.block.items" :key="index">
        <div v-if="item.length" class="d-flex">
          <span class="text-nowrap reference" />
          <div class="flex-grow-1">
            <component
              v-for="(itemBlock, index) in item"
              :key="index"
              :is="itemBlock.type"
              :block="itemBlock"
              :blocks="blocks"
              :definitions="definitions"
              :asset="asset"
              :showActions="showActions"
            />
          </div>
        </div>
      </li>
    </ol>
  </div>
</template>

<script>
import helpers from '@/Mixins/helpers';
import contractComponents from '@/Mixins/contractComponents';
import contractHelpers from '@/Mixins/contractHelpers';

export default {
  mixins: [helpers, contractComponents, contractHelpers],

  props: {
    dynamic: {
      type: Boolean,
      default: false,
    },
    block: Object,
    blocks: Array,
    definitions: Array,
    showActions: Boolean,
    asset: Object,
  },
};
</script>
